import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  voucher: {
    id: "9BvYb9",
    defaultMessage: "Voucher",
  },
  minSpent: {
    id: "tuYPlG",
    defaultMessage: "Min. Spent",
    description: "minimum amount of spent money to activate voucher",
  },
  starts: {
    id: "5u7b3V",
    defaultMessage: "Starts",
    description: "voucher is active from date",
  },
  ends: {
    id: "b6L9n7",
    defaultMessage: "Ends",
    description: "voucher is active until date",
  },
  value: {
    id: "JV+EiM",
    defaultMessage: "Value",
    description: "voucher value",
  },
  uses: {
    id: "yHwvLL",
    defaultMessage: "Uses",
    description: "voucher uses",
  },
});

export const messages = defineMessages({
  empty: {
    id: "U2mOqA",
    defaultMessage: "No vouchers found",
  },
});
